import { Box, Table, TableBody, TableRow, TableCell } from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'

const ExpensesTableSection = ({
  label,
  open,
  handleOpen,
  sums,
  fontSizeCell,
  paddingLeft,
}) => {
  const fontStyle = { fontWeight: 'bold', color: '#183a60', textAlign: 'right' }

  return (
    <Box sx={{ marginLeft: 'auto', marginRight: '25px', minHeight: '40px' }}>
      <Box component={Table} size="small">
        <TableBody>
          <TableRow
            onClick={handleOpen}
            sx={{
              '&:hover': { backgroundColor: '#e1e1e1' },
              cursor: 'pointer',
            }}
          >
            <TableCell
              sx={{
                fontSize: fontSizeCell,
                ...fontStyle,
                textAlign: 'left',
                alignItems: 'center',
                display: 'flex',
                paddingLeft: paddingLeft,
              }}
            >
              <ExpandMoreIcon
                style={{ transform: open ? 'rotate(0deg)' : 'rotate(-90deg)' }}
              />
              {label.toUpperCase()}
            </TableCell>
            <TableCell
              sx={{
                width: { lg: '9%', xs: '12%' },
                fontSize: fontSizeCell,
                ...fontStyle,
              }}
            >
              {new Intl.NumberFormat('fr-FR', {
                style: 'currency',
                currency: 'EUR',
              }).format(sums?.montant / 100)}
            </TableCell>
            <TableCell
              sx={{
                width: { lg: '9%', xs: '12%' },
                fontSize: fontSizeCell,
                ...fontStyle,
              }}
            >
              {new Intl.NumberFormat('fr-FR', {
                style: 'currency',
                currency: 'EUR',
              }).format(Math.abs(sums?.tva) / 100)}
            </TableCell>
            <TableCell
              sx={{
                width: { lg: '9%', xs: '12%' },
                fontSize: fontSizeCell,
                ...fontStyle,
              }}
            >
              {new Intl.NumberFormat('fr-FR', {
                style: 'currency',
                currency: 'EUR',
              }).format(Math.abs(sums?.recuperable) / 100)}
            </TableCell>
            <TableCell
              sx={{
                width: { lg: '9%', xs: '12%' },
                fontSize: fontSizeCell,
                ...fontStyle,
              }}
            >
              {new Intl.NumberFormat('fr-FR', {
                style: 'currency',
                currency: 'EUR',
              }).format(Math.abs(sums?.deductible) / 100)}
            </TableCell>
          </TableRow>
        </TableBody>
      </Box>
    </Box>
  )
}

export default ExpensesTableSection
